import React, { memo, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { getVisitPartsActions } from '../../../redux/actions/visitPartsActions';
import Button from '../../shared/buttons/Button';
import ContainerHeader from '../../shared/container/ContainerHeader';
import ContainerTitle from '../../shared/container/ContainerTitle';
import CreateVisitPartModal from './modals/CreateVisitPartModal';

const VisitPartsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { vin, id } = useSelector((state) => state.visit?.visit);
  const [showCreateVisitPartModal, setShowCreateVisitPartModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleVisitPartModalSubmit = async () => {
    setShowCreateVisitPartModal(false);
    setLoading(true);
    await dispatch(getVisitPartsActions(vin, id));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateVisitPartModal && (
        <CreateVisitPartModal
          onModalSubmit={() => handleVisitPartModalSubmit()}
          onModalClose={() => setShowCreateVisitPartModal(false)}
        />
      )}
      <ContainerTitle title={'Деталі візиту'} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateVisitPartModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default memo(VisitPartsHeader);
